const base_api_maubelajrapa   = "https://api.maubelajarapa.com"
const base_api_masteringskill = "https://kelas.masteringskill.com"

export const get_data_course = (slug) => fetch(
    `${base_api_maubelajrapa}/thinkific/courses/?slug=${slug}`
    );

export const submit_voucher  = (productId, couponCode, prefix) => {
    window.location.href = `${base_api_masteringskill}/enroll/${productId}?coupon=${couponCode.replace(prefix, '')}`
    return;
}